"use client";

import { Button } from "@/components/ui/button";
import { Simplify } from "@/prismicio-types";
import { Content } from "@prismicio/client";
import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import { motion } from "framer-motion";

type Props = {
  service: Simplify<Content.AdditionalServicesSectionSliceDefaultPrimaryServicesItem>;
};

export default function ServiceCard({ service }: Props) {
  return (
    <div className="flex items-start gap-7 border-b-2 border-secondary/20 py-8">
      {/* icon */}
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeInOut" }}
        viewport={{ once: true }}
      >
        <Button size="icon" className="rounded-full bg-[#EBF7FF] size-14">
          <PrismicNextImage field={service.icon} alt="" className="size-8" />
        </Button>
      </motion.div>

      {/* texts */}
      <motion.div
        className="space-y-3"
        initial={{ y: 30, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4, ease: "easeInOut", delay: 0.8 }}
        viewport={{ once: true }}
      >
        {/* heading */}
        <PrismicRichText
          field={service.title}
          components={{
            heading1: ({ children }) => (
              <h1 className="text-primary text-3xl font-semibold">
                {children}
              </h1>
            ),
            heading2: ({ children }) => (
              <h2 className="text-primary text-3xl font-semibold">
                {children}
              </h2>
            ),
            heading3: ({ children }) => (
              <h3 className="text-primary text-3xl font-semibold">
                {children}
              </h3>
            ),
            heading4: ({ children }) => (
              <h4 className="text-primary text-3xl font-semibold">
                {children}
              </h4>
            ),
            heading5: ({ children }) => (
              <h5 className="text-primary text-3xl font-semibold">
                {children}
              </h5>
            ),
            heading6: ({ children }) => (
              <h6 className="text-primary text-3xl font-semibold">
                {children}
              </h6>
            ),
          }}
        />

        {/* sub heading */}

        <PrismicRichText
          field={service.description}
          components={{
            paragraph: ({ children }) => (
              <p className="font-merriweather text-lg font-normal text-primary">
                {children}
              </p>
            ),
          }}
        />
      </motion.div>
    </div>
  );
}
